<template>
  <div class="cancel-ai-visibility-modal">
    <div v-if="getPackagesLoading" class="modal-loading">
      <loader />
    </div>
    <span class="kw kw-x" @click="close" />
    <p class="title">
      {{ $t('cancel-ai-visibility-sub') }}
    </p>

    <p class="desc">
      {{ $t('are-you-sure-cancel-ai-visibility') }}
    </p>

    <div class="cancel-ai-visibility-note" v-html="$t('cancel-ai-visibility-note')" />

    <kw-button :button-text="$t('cancel-ai-visibility')" button-type="danger" @click="submit" :loading="loading" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'CancelAiVisibilityModal',
  directives: {
    ClickOutside,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['getPackages', 'getPackagesLoading', 'getAiVisibilitySubscription']),
  },
  mounted() {
    this.fetchPackages();
  },
  methods: {
    ...mapActions(['cancelAiVisibilitySubscription', 'fetchPackages']),
    submit() {
      this.loading = true;
      this.cancelAiVisibilitySubscription(this.getAiVisibilitySubscription.package_identity)
        .then((res) => {
          if (res) this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/modal';
.cancel-ai-visibility-modal {
  position: relative;
  width: 100%;
  padding: 14px 30px 20px 16px;
  font-family: Roboto;

  p.title {
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    margin-bottom: 24px;
  }
  p.desc {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 16px;
  }

  .kw-x {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 7px;
    right: 7px;
    font-size: 10px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    font-weight: 900;
    color: kw-color(kw-light-grey, 4);
  }

  .cancel-ai-visibility-note {
    ::v-deep ul {
      font-size: 13px;
      padding-left: 20px;
    }
  }
  button.kw-button.kw-btn-danger {
    margin: 24px auto 0;
    padding: 6px 34px;
    min-width: 200px;
  }
  .modal-loading {
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
